import React from "react";
const Contact = () => {
  return (
    <div className="rollingContent">
      <div className="contentImage07">
        <div className="contentImage05-txt01">
          <img
            src={require("../images/rolling05-txt01.png")}
            alt="rolling05-txt01"
          />
        </div>
        <div className="contentImage05-txt02">
          <img
            src={require("../images/rolling05-txt02.png")}
            alt="rolling05-txt02"
          />
        </div>
        <div className="contentImage05-txt03">
          <img
            src={require("../images/rolling05-txt03.png")}
            alt="rolling05-txt03"
          />
        </div>
        <div className="contentImage05-txt04">
          <img
            src={require("../images/rolling05-txt04.png")}
            alt="rolling05-txt04"
          />
        </div>
        <div className="contentImage05-txt05">
          <img
            src={require("../images/rolling05-txt05.png")}
            alt="rolling05-txt05"
          />
        </div>
        <div className="contentImage05-txt06">
          <ul>
            <li>
              <img src={require("../images/cicon01.png")} alt="cicon01" />
              <b>이메일 문의 : </b>
              <a href="mailto:">kevin85.oh@gmail.com</a>
            </li>
            {/* <li><img src={require('../images/cicon02.png')} alt="cicon02" /><b>카카오톡 문의 :</b>youngmapinfo</li> */}
            <li>
              <img src={require("../images/cicon03.png")} alt="cicon03" />
              <b>인스타그램 : </b>youngmap_app{" "}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Contact;
